import { apiPaths } from 'app/services/api';
import React from 'react';
import useExistingUser from 'app/hooks/useExistingUser';
import CrudGridForm from '../../smart-kit/Form/CrudGridForm';
import { MOBILE_REGEX } from '../../smart-kit/Form/gridFormUtils';

export const customerFields = [
  // main
  {
    label: 'Mobile Number',
    type: 'number',
    key: 'mobile_number',
    validation: { required: true, pattern: MOBILE_REGEX },
    watch: true,
  },
  {
    label: 'Name',
    group: 'Name',
    groupIndex: 0,
    key: 'first_name',
    validation: { required: true },
  },
  {
    label: 'Last Name',
    group: 'Name',
    groupIndex: 1,
    key: 'last_name',
    validation: { required: true },
  },
  {
    label: 'Customer National Id',
    type: 'number',
    key: 'national_id',
    // validation: { required: true, pattern: MOBILE_REGEX },
    // watch: true,
  },
  // {
  //   label: 'English Name',
  //   group: 'English Name',
  //   groupIndex: 0,
  //   key: 'eng_first_name',
  //   validation: { required: true },
  // },
  // {
  //   label: 'English Last Name',
  //   group: 'English Name',
  //   groupIndex: 1,
  //   key: 'eng_last_name',
  //   validation: { required: true },
  // },
  // { label: 'City', key: 'city', validation: { required: false } },
  {
    label: 'Profile Pic',
    key: 'profile_pic',
    type: 'image',
    purpose: 'profile_pic',
    validation: { required: false },
  },
  // {
  //   label: 'National Card Pic',
  //   key: 'national_card_pic',
  //   type: 'image',
  //   purpose: 'national_card_pic',
  //   validation: { required: false }
  // },

  // { label: 'Birth Date', key: 'birth_date', type: 'date', validation: { required: false } },
  // {
  //   label: 'Gender',
  //   key: 'gender',
  //   type: 'radio',
  //   items: [
  //     { value: 'male', label: 'Male' },
  //     { value: 'female', label: 'Female' },
  //     { value: 'other', label: 'Other' }
  //   ],
  //   validation: { required: false }
  // },

  // {
  //   label: 'Customer Type',
  //   key: 'type',
  //   type: 'radio',
  //   items: [
  //     { value: 'organisational', label: 'Organisational' },
  //     { value: 'individual', label: 'Individual' }
  //   ],
  //   validation: { required: false },
  //   auth: ['admin']
  // },

  // {
  //   label: 'Company',
  //   key: 'company_uuid',
  //   type: 'auto_complete',
  //   options: { entity: 'companies', path: apiPaths.COMPANIES },
  //   show: { key: 'type', value: 'organisational' },
  //   validation: { required: true }
  // }

  // seller info
];
const CustomerForm = () => {
  const [defaultValues, onChange] = useExistingUser();

  return (
    <CrudGridForm
      path={apiPaths.CUSTOMERS}
      name="Customer"
      entityName={'users'}
      fields={customerFields}
      watches={['customer_type']}
      onChange={onChange}
      defaultValues={defaultValues}
    />
  );
};

export default CustomerForm;
